var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6,25h12c1,0,1.8-0.8,1.8-1.8V19h1.8c1.9,0,3.4-1.5,3.4-3.4V8c0-1.9-1.5-3.4-3.4-3.4h-1.8V0.8 C19.8-0.2,19-1,18-1H6C5-1,4.2-0.2,4.2,0.8v3.8H2.4C0.5,4.6-1,6.1-1,8v7.6c0,1.9,1.5,3.4,3.4,3.4h1.8v4.2C4.2,24.2,5,25,6,25z  M17.8,23H6.2v-5c0-0.6-0.4-1-1-1H2.4C1.6,17,1,16.4,1,15.6V8c0-0.8,0.6-1.4,1.4-1.4h2.8c0.6,0,1-0.4,1-1V1h11.6v4.6 c0,0.6,0.4,1,1,1h2.8C22.4,6.6,23,7.2,23,8v7.6c0,0.8-0.6,1.4-1.4,1.4h-2.8c-0.6,0-1,0.4-1,1V23z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17,6.6H7v-5h10V6.6z M9,4.6h6v-1H9V4.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17,22.4H7v-8h10V22.4z M9,20.4h6v-4H9V20.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.b15a090bdc3739bf73503f601203e4fe.svg";
export { ForwardRef as ReactComponent };